type I18nProvide = {
  localeSync: (log: `from:${string}`, lang?: Locales) => void
}

export function i18nProvide(inp: I18nProvide): I18nProvide {
  return inp
}

export default defineNuxtPlugin({
  parallel: false,
  async setup() {
    const localeStateSave = useLocaleState()
    // const inited = shallowRef(true)
    const auth = useAuth()
    const { rewrite } = useI18nRouteRewrite()
    const route = useRoute()
    const toRouteLang = (path: string): Locales | undefined => checkRouteLocale(locales.en, path) ? locales.en : checkRouteLocale(locales.lt, path) ? locales.lt : undefined
    const { track } = useAnalytics()
    let loading = false

    async function go(log: string, next: Locales) {
      if (loading) return
      // if (loading || !inited.value) {
      //   initSync = next
      //   return
      // }

      const changeLocale = next !== localeStateSave.locale.value
      const changeAuth = next !== auth.value.lang && !auth.value.loading
      const routeLang = toRouteLang(route.path)
      const changeRoute = next !== routeLang
      if (!changeLocale && !changeAuth && !changeRoute) return

      try {
        loading = true
        track(() => ({
          name: `[lang:${log}]`,
          eventJson: JSON.stringify({
            locale: localeStateSave.locale.value,
            next,
            log,
            'auth.lang': auth.value.lang,
            routeLang,
            changeLocale,
            changeAuth,
            changeRoute,
            auth: auth.value,
          }),
        }))

        localeStateSave.set(next)
        if (changeLocale) await useNuxtApp()?.$apollo?.get.resetStore().catch((err) => console.error('[lang:resetStore]', err))
        if (changeAuth) await (await import('@/composables/useBuyerInformationUpdate')).useBuyerInformationUpdate({ langSet: { lang: next } }).catch((err) => console.error('[lang:langSet]', err))
        const redirect = changeRoute ? rewrite(route, next) : undefined
        if (redirect && redirect.path !== route.path) await navigateTo(redirect, { redirectCode: 302 })
      } catch (err) {
        console.error('[lang:catch]', err)
      } finally {
        await helpers.sleep(1000)
        loading = false
      }
    }

    function localeSync(log: `from:${string}`, lang?: Locales) {
      if (loading) return
      const next = lang ?? toRouteLang(route.path) ?? auth.value.lang
      if (!next) localeStateSave.set('en')
      else go(log, next).catch((err) => console.error('[lang:localeSync:go]', err))
    }

    // watch(() => inited.value, () => initSync && !localeStateSave.locale.value && localeSync('from:inited', initSync), { once: true })

    watch(() => route.path, (path) => {
      if (loading) return
      const lang = toRouteLang(path)
      if (lang) localeSync('from:checkRoute', lang)
    }, { immediate: true })

    return { provide: i18nProvide({ localeSync }) }
  },
})
